import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import BlogListItem from '../../blog/components/BlogListItem.js';
import { CmsAPI } from '../../../api';
import Button from '../../../components/Button';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.common.paleGrey,
    padding: '9rem 1.5rem',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'center',
  },
  title: {
    padding: '0',
    width: '100%',
    textAlign: 'center',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
      padding: '0 1.5rem',
    },
  },
  text: {
    width: '100%',
    textAlign: 'center',
    lineHeight: '2rem',
    marginBottom: '1rem',
    padding: '0 10rem',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
      padding: '0 1.5rem',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '4rem',
  },
  button: {
    padding: '1rem 2rem',
  },
}));

const BlogSection = () => {
  const classes = useStyles();
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    CmsAPI.getBlogRecent().then((content) => setRecent(content.payload));
  }, []);

  return (
    <div className={classes.root}>
      <Container maxWidth="lg" fixed disableGutters={true}>
        <Grid container spacing={6}>
          <Grid item md={12}>
            <Typography variant="h1" color="primary" className={classes.title}>
              Have you read our blog?
            </Typography>
            <Typography variant="h3" className={classes.text}>
              Stories and advice by the disability community, for the disability community. We&apos;ve been writing about the issues that matter for over 5 years so if it&apos;s important, we&apos;ve got an article about it!
            </Typography>
          </Grid>
          <Grid item md={6}>
            {recent.length > 0 && <BlogListItem item={recent[0]} />}
          </Grid>
          <Grid item md={6}>
            {recent.length > 1 && <BlogListItem item={recent[1]} />}
          </Grid>
          <Grid item md={6}>
            {recent.length > 2 && <BlogListItem item={recent[2]} />}
          </Grid>
          <Grid item md={6}>
            {recent.length > 3 && <BlogListItem item={recent[3]} />}
          </Grid>
        </Grid>
        <div className={classes.buttonContainer}>
          <Button
            label="View more"
            to="/blog"
            variant="contained"
            className={classes.button}
          />
        </div>
      </Container>
    </div>
  );
};

export default BlogSection;
